export interface AuraProcessingCostConversation {
    id: number;
    title: string | null;
    userId: number;
    userName: string;
}

export interface AuraProcessingCost {
    id: number;
    levelId: number;
    verticalId: number;
    callId: number | null;
    sourceType: string;
    sourceId: number | null;
    processingType: string;
    category: string;
    status: string;
    processingVersion: string | null;
    startedAt: string;
    completedAt: string | null;
    durationMs: number | null;
    tokensUsed: number | null;
    costUsd: number;
    errorMessage: string | null;
    conversation: AuraProcessingCostConversation | null;
}

export interface AuraProcessingCostsResponse {
    success: boolean;
    data: {
        items: AuraProcessingCost[];
        total: number;
        page: number;
        perPage: number;
        users: Array<{ id: number; name: string }>;
        activatedAt: string | null;
        totalCost: number;
        totalTokens: number;
    };
}

export interface AuraProcessingCostsFilters {
    dateFrom?: string;
    dateTo?: string;
    processingType?: string;
    status?: string;
    search?: string;
    userId?: number;
    page?: number;
    perPage?: number;
    sort?: string;
}
